import React, { useState } from 'react';
import { Box, Button, Grid, Typography, Divider } from '@mui/material';
import { useSelector } from 'react-redux';
import ContainerBox from 'components/ContainerBox';
import LanguageSelectModal from '../components/LanguageSelectModal';
import DefaultLanguage from '../components/DefaultLanguage';
import * as ShopSelectors from 'selectors/ShopSelectors';
import * as UserSelectors from 'selectors/UserSelectors';
import { useTranslation } from 'services/localization';
import { getLanguageName } from 'common/locales/utils';
import HasFeature from 'components/features/HasFeature';
import UpgradeButton from 'components/features/UpgradeButton';
import { push, Routes } from 'routing';

const LanguageSettings = () => {
	const { t } = useTranslation();
	const shopLanguages = useSelector(ShopSelectors.activeShopLanguages);
	const isAdmin = useSelector(UserSelectors.isAdmin);
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

	return (
		<Box>
			<ContainerBox>
				<Grid container spacing={2}>
					<Grid item xs={12} md={6}>
						<Typography variant="h5">
							{t('account.languages.languageSettings.mainLanguageTitle', 'Main language')}
						</Typography>
						<Typography color="textSecondary" variant="body2">
							{t(
								'account.languages.languageSettings.mainLanguageDescription',
								'The language you create your content in',
							)}
						</Typography>
					</Grid>
					<Grid item xs={12} md={6}>
						<DefaultLanguage />
					</Grid>
				</Grid>
			</ContainerBox>

			<ContainerBox>
				<Grid container spacing={2}>
					<Grid item xs={12} md={6}>
						<Typography variant="h5">
							{t('account.languages.languageSettings.enabledLanguagesTitle', 'Enabled languages')}
						</Typography>
					</Grid>
					<Grid item xs={12} md={4}>
						{shopLanguages.map((lang) => {
							return (
								<Box key={lang} mt={2} mb={2}>
									<Box mb={2}>
										<Typography>{getLanguageName(lang, t)}</Typography>
									</Box>
									<Divider />
								</Box>
							);
						})}
					</Grid>

					<Grid item xs={12} md={6} />
					<HasFeature
						requiredFeature="LANGUAGES"
						fallback={
							<Grid item xs={12} md={6}>
								<UpgradeButton
									text={t(
										'account.languages.languageSettings.addMoreLanguages',
										'Add more languages',
									)}
									onClick={() => push(Routes.LanguagesTab('translations'))}
								/>
							</Grid>
						}
					>
						{isAdmin && (
							<Grid item xs={12} md={6}>
								<Button variant="outlined" color="primary" onClick={() => setIsModalOpen(true)}>
									{t('account.languages.languageSettings.manageLanguages', 'Manage languages')}
								</Button>
							</Grid>
						)}
					</HasFeature>
					<LanguageSelectModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
				</Grid>
			</ContainerBox>
		</Box>
	);
};

export default LanguageSettings;
